<template>
  <div>
    <a-row>
      <div>
        <a-date-picker
          v-model="from"
          style="margin-right: 10px"
          :disabled-date="disabledStartDate"
          :format="'DD-MMM YYYY HH:mm'"
          :show-time="{ format: 'HH:mm' }"
          placeholder="Начало"
          @openChange="handleStartOpenChange"
        />
        <span>—</span>
        <a-date-picker
          v-model="till"
          style="margin-left: 10px"
          :disabled-date="disabledEndDate"
          :format="'DD-MMM YYYY HH:mm'"
          :show-time="{ format: 'HH:mm' }"
          placeholder="Конец"
          :open="endOpen"
          @openChange="handleEndOpenChange"
        />

        <a-button type="primary" style="margin-left: 15px" @click="fetchData">
          Найти
        </a-button>
      </div>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-table
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :row-key="() => Math.random().toString().slice(2)"
      >
        <template slot="id" slot-scope="item">
          {{ item.author.id }}
        </template>
        <template slot="fullName" slot-scope="item">
          {{ item.author.first_name }} {{ item.author.last_name }}
        </template>
        <template slot="totalNews" slot-scope="item">
          {{ item.total_news }}
        </template>
        <template slot="acceptedNews" slot-scope="item">
          {{ item.accepted_news }}
        </template>
        <template slot="rejectedNews" slot-scope="item">
          {{ item.rejected_news }}
        </template>
      </a-table>
      <a-pagination
        style="margin-top: 15px"
        :current="+$route.query.page || 1"
        :total="count"
        :page-size="+$route.query.limit || 10"
        @change="toPage"
      />
    </a-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

const columns = [
  {
    title: "ID",
    scopedSlots: { customRender: "id" },
    width: "10%"
  },
  {
    title: "ФИО",
    scopedSlots: { customRender: "fullName" },
    width: "30%"
  },
  {
    title: "Кол-во одобренных статей",
    scopedSlots: { customRender: "totalNews" },
    width: "15%"
  },
  {
    title: "Кол-во одобренных статей",
    scopedSlots: { customRender: "acceptedNews" },
    width: "15%"
  },
  {
    title: "Кол-во отказанных статей",
    scopedSlots: { customRender: "rejectedNews" },
    width: "15%"
  }
]

export default {
  name: "StatTable",
  data() {
    return {
      loading: false,
      pending: false,
      from: null,
      till: null,
      endOpen: false,
      columns
      // count: 0,
    }
  },

  computed: {
    ...mapState({
      list: (state) => state.statistics.results,
      count: (state) => state.statistics.items_count
    })
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  methods: {
    ...mapActions("statistics", ["fetchSortByDate"]),
    toPage(page) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page
        }
      })
    },
    async fetchData() {
      this.loading = true
      try {
        const params = {
          from: this.moment(this.from).format("YYYY-MM-DD") || null,
          till: this.moment(this.till).format("YYYY-MM-DD") || null,
          limit: this.$route.query.limit || 10,
          page: this.$route.query.page || 1
        }

        await this.fetchSortByDate(params)
      } catch (err) {
        console.error(err)
        return
      }
      this.loading = false
    },
    disabledStartDate(startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    }
  }
}
</script>

<style></style>
